import { render, staticRenderFns } from "./watch.vue?vue&type=template&id=926e2b0c&scoped=true"
import script from "./watch.vue?vue&type=script&lang=js"
export * from "./watch.vue?vue&type=script&lang=js"
import style0 from "./watch.vue?vue&type=style&index=0&id=926e2b0c&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926e2b0c",
  null
  
)

export default component.exports